import { useState } from "react";
import { Box } from "../../../../../../components/box";
import InformationLayout from "../../../../components/layout/InformationLayout";
import FormButton from "./button";
import FormContent from "./content";

const ItToolInformation = () => {
  /**
   * Form states
   */
  const [employeeName, setEmployeeName] = useState<any>([]);

  return (
    <InformationLayout>
      <Box title="Thông tin cấp vật tư" className="full-height">
        <FormContent setEmployeeName={setEmployeeName} />

        <FormButton employeeName={employeeName} />
      </Box>
    </InformationLayout>
  );
};

export default ItToolInformation;
